import type { SxProps, Theme } from '@mui/material/styles';

const body14 = {
  fontSize: 14,
  lineHeight: (theme: Theme) => theme.typography.button.lineHeight,
} as const;

export const rootSx = (disabled: boolean): SxProps<Theme> => ({
  gap: 1,
  width: '100%',
  pointerEvents: disabled ? 'none' : 'auto',
});

export const cardSx: SxProps<Theme> = {
  boxSizing: 'border-box',
  width: '100%',
  px: 3,
  py: 2,
  backgroundColor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '8px',
};

export const headerSx: SxProps<Theme> = { display: 'flex', alignItems: 'flex-start', gap: 1, minHeight: 22 };

export const iconSx = (color: string): SxProps<Theme> => ({ width: 22, height: 22, color, flexShrink: 0 });

export const titleSx = (color: string): SxProps<Theme> => ({
  m: 0,
  minWidth: 0,
  fontSize: 16,
  lineHeight: theme => theme.typography.body2.lineHeight,
  fontWeight: 'fontWeightMedium',
  color,
});

export const listSx: SxProps<Theme> = { listStyle: 'none', m: 0, mt: 1, p: 0 };

export const rowSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 130px) minmax(80px, 1fr) minmax(40px, auto)',
  alignItems: 'center',
  columnGap: 1.5,
  minHeight: 36,
};

export const nameSx = (color: string): SxProps<Theme> => ({ minWidth: 0, ...body14, color });

export const scoreWrapperSx: SxProps<Theme> = { display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 };

export const progressSx = (color: string): SxProps<Theme> => ({
  flex: 1,
  minWidth: 0,
  height: 8,
  borderRadius: 4,
  backgroundColor: 'transparent',
  '& .MuiLinearProgress-bar': {
    borderRadius: 4,
    backgroundColor: color,
  },
});

export const scoreSx = (color: string): SxProps<Theme> => ({
  width: 32,
  flexShrink: 0,
  ...body14,
  fontWeight: 'fontWeightMedium',
  textAlign: 'right',
  color,
});

export const metricSx = (color: string): SxProps<Theme> => ({
  minWidth: 40,
  fontSize: 13,
  textAlign: 'right',
  whiteSpace: 'nowrap',
  color,
});

export const summarySx = (color: string): SxProps<Theme> => ({ m: 0, width: '100%', color });

export const summaryIntroSx: SxProps<Theme> = { m: 0, mb: 0.5, ...body14, color: 'inherit' };

export const statListSx: SxProps<Theme> = { m: 0, pl: 3, listStyleType: 'disc' };

export const statRowSx: SxProps<Theme> = { minHeight: 20, ...body14, '&:not(:last-of-type)': { mb: 0.5 } };

export const statTermSx: SxProps<Theme> = { ...body14, color: 'inherit' };

export const statValueSx: SxProps<Theme> = { ...body14, fontWeight: 'fontWeightMedium', color: 'inherit' };
